import { Component } from '@stencil/core';
import state from '@ugc-store';
import { addDataLayer } from '@ugc-utils/utils';
import { GAImpressionTracker } from '@ugc-utils/ga-impression-tracker';

@Component({
  tag: 'ugc-qna-scroll-ga',
  shadow: false,
})
export class UgcQnaScrollGa {
  constructor() {
    try {
      const qnaSection: HTMLDivElement = document.querySelector('.ugc-pdp-qna-section');
      const tracker = new GAImpressionTracker(qnaSection, {
        gaCallback: this._sendViewGA.bind(this),
        threshold: 0.05,
        rootMargin: state.isDesktop ? '-120px 0px 0px 0px' : '-64px 0px 0px 0px',
      });
      tracker.init();
    } catch (e) {}
  }

  _sendViewGA() {
    const {
      productInfo: { partNumber },
    } = state;
    addDataLayer({ parameters: null });
    addDataLayer({
      event: 'view_item_ugc',
      parameters: {
        ugc_content: 'qna',
        item_part_number: partNumber,
      },
    });
  }

  render() {
    return null;
  }
}
